import React, { ReactElement } from 'react'
import { Flex, Text } from 'theme-ui'
import { Svg } from 'ui'
import WithoutControlDIcon from 'images/homePage/without.svg'
import WithControlDIcon from 'images/homePage/with.svg'
import { CONTROLDText } from 'ui/CONTROLD'

const title = <>How does {CONTROLDText} work?&nbsp; </>

const description = (
  <>
    {CONTROLDText} is a fully customizable DNS service, similar to Pi-Hole, AdGuard or NextDNS, but
    with proxy capabilities. This means it not only blocks things (ads, porn, etc), but can also
    unblock websites and services.
  </>
)

const HowDoesControlDWorkSection = (): ReactElement => {
  return (
    <Flex
      sx={{
        backgroundColor: 'darkItemBG50',
        boxShadow: ({ colors }): string => `0 1.6rem 2.4rem 0 ${colors?.darkItemBoxShadow}`,
        py: ['2.4rem', '4.8rem'],
        px: ['1.6rem', '4.8rem'],
        borderRadius: '32px',
        mt: '4rem',
        justifyContent: 'center',
        alignSelf: 'center',
        width: '100%',
      }}
    >
      <Flex
        sx={{
          flexDirection: 'column',
          width: ['fit-content', '62.4rem', '100%'],
          textAlign: ['center', 'center', 'left'],
        }}
      >
        <Text
          as="h2"
          sx={{
            fontSize: ['2.8rem', '4rem'],
            mb: ['2.4rem', '3.2rem'],
            fontWeight: 'bold',
          }}
        >
          {title}
        </Text>
        <Text
          sx={{
            fontSize: ['1.8rem', '2.1rem'],
            color: 'aliceBlue60',
            mb: [0, '4.8rem'],
          }}
        >
          {description}
        </Text>
        <Flex sx={{ display: ['none', 'flex'], flexDirection: 'column', alignItems: 'center' }}>
          <Svg
            svg={WithoutControlDIcon}
            sx={{ mb: '4.8rem', width: '54.2rem', height: '20.8rem' }}
            descriptiveText="Diagram showing how DNS works without Control D"
          />
          <Svg
            svg={WithControlDIcon}
            sx={{ width: '62.2rem', height: '20.8rem' }}
            descriptiveText="Diagram showing how DNS works with Control D"
          />
        </Flex>
      </Flex>
    </Flex>
  )
}

export default HowDoesControlDWorkSection
